import script from "./TableWithStickyHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableWithStickyHeader.vue?vue&type=script&lang=ts&setup=true"

import "./TableWithStickyHeader.vue?vue&type=style&index=0&id=ce1f1b28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce1f1b28"]])

export default __exports__